import { createAsyncThunk, createSlice, PayloadAction } from "@reduxjs/toolkit";
import fetchTimeliveAPI from "../../../common/fetchTimeliveAPI";
import { RootState } from "../../../app/store";
import { IThunkApi } from "../../timesheet/timesheetSlice";

interface GeofencingStateClass {
    isLoading: boolean
    status: 'idle' | 'loading' | 'failed';
    zoneTypeList: any[];
    zoneList: any[];
    profileList: any[];
    radiusUnit: any[];
    totalItems: number; 
    pageNo: number; 
    pageSize: number;
    startRec:number;
    totalProfileItems: number; 
    profilePageNo: number; 
    profilePageSize: number;
    startProfileRec:number;
}

const initialState: GeofencingStateClass = {
    isLoading: true,
    status: "idle",
    zoneTypeList: [],
    zoneList: [],
    profileList: [],
    radiusUnit: [],
    totalItems: 0, 
    pageNo: 1, 
    pageSize: 10,
    startRec: 0,
    totalProfileItems: 0, 
    profilePageNo: 1, 
    profilePageSize: 10,
    startProfileRec: 0
}

export const getAccountGeoFenceZoneType = createAsyncThunk
    <any, void, IThunkApi>
    (
        "api/GeoFenceZoneType/GetAccountGeoFenceZoneType",
        async (arg, thunkApi) => {
            const response = await fetchTimeliveAPI("api/GeoFenceZoneType/GetAccountGeoFenceZoneType", "GET", "", true, "0df3ab0c-4033-4013-8b1e-2f0b64f8cbab");
            const json = response.json();
            return json;
        }

    )
export const getAccountGeoFenceZoneTypeById = createAsyncThunk
    <any, any, IThunkApi>
    (
        'api/GeoFenceZoneType/GetAccountGeoFenceZoneTypeById',
        async (arg, thunkApi) => {
            const response = await fetchTimeliveAPI(`api/GeoFenceZoneType/GetAccountGeoFenceZoneTypeById/${arg}`, 'GET', '', true);
            const json = await response.json();
            return json;
        }
    );

export const DeleteAccountGeoFenceZoneType = createAsyncThunk
    <any, any, IThunkApi>
    (
        'GeoFenceZoneType/DeleteAccountGeoFenceZoneType',
        async (arg, thunkApi) => {
            const response = await fetchTimeliveAPI(`api/GeoFenceZoneType/DeleteAccountGeoFenceZoneType/${arg}`, `DELETE`, '', true);
            const json = await response.json();
            return json;
        }
    )

export const GetAccountGeoFenceZone = createAsyncThunk
    <any, any, IThunkApi>
    (
        "api/GeoFenceZone/GetAccountGeoFenceZone",
        async (arg, thunkApi) => {
            const {pageNumber, pageSize}= arg
            const response = await fetchTimeliveAPI(`api/GeoFenceZone/GetAccountGeoFenceZone/${pageNumber}/${pageSize}`, "GET", "", true, "0df3ab0c-4033-4013-8b1e-2f0b64f8cbab");
            const json = response.json();
            return json;
        }

    )

export const GetAccountGeoFenceZoneById = createAsyncThunk
    <any, any, IThunkApi>
    (
        'api/GeoFenceZone/GetAccountGeoFenceZoneById',
        async (arg, thunkApi) => {
            const response = await fetchTimeliveAPI(`api/GeoFenceZone/GetAccountGeoFenceZoneById/${arg}`, 'GET', '', true);
            const json = await response.json();
            return json;
        }
    );

export const SystemGeoFenceBoundaryBehavior = createAsyncThunk
    <any, void, IThunkApi>
    (
        "api/SystemGeoFenceBoundaryBehavior",
        async (arg, thunkApi) => {
            const response = await fetchTimeliveAPI("api/SystemGeoFenceBoundaryBehavior", "GET", "", true, "0df3ab0c-4033-4013-8b1e-2f0b64f8cbab");
            const json = response.json();
            return json;
        }
    )

export const GetAccountGeoFenceProfile = createAsyncThunk
    <any, any, IThunkApi>
    (
        "api/GeoFenceProfile/GetAccountGeoFenceProfile",
        async (arg, thunkApi) => {
            const {profilePageNo, profilePageSize}= arg
            const response = await fetchTimeliveAPI(`api/GeoFenceProfile/GetAccountGeoFenceProfile/${profilePageNo}/${profilePageSize}`, "GET", "", true, "0df3ab0c-4033-4013-8b1e-2f0b64f8cbab");
            const json = response.json();
            return json;
        }

    )

export const GetAccountGeoFenceProfileById = createAsyncThunk
    <any, any, IThunkApi>
    (
        'api/GeoFenceProfile/GetAccountGeoFenceProfileById',
        async (arg, thunkApi) => {
            const response = await fetchTimeliveAPI(`api/GeoFenceProfile/GetAccountGeoFenceProfileById/${arg}`, 'GET', '', true);
            const json = await response.json();
            return json;
        }
    );

export const SystemRadiusUnitController = createAsyncThunk
    <any, void, IThunkApi>
    (
        "api/SystemRadiusUnitController",
        async (arg, thunkApi) => {
            const response = await fetchTimeliveAPI("api/SystemRadiusUnitController", "GET", "", true, "0df3ab0c-4033-4013-8b1e-2f0b64f8cbab");
            const json = response.json();
            return json;
        }

    )

const geofencingSlice = createSlice({
    name: "geofencing",
    initialState,
    reducers: {
        setPageNo: (state, action) => { 
            state.pageNo = action.payload; 
        },
        setPageSize: (state, action) => { 
            state.pageSize = action.payload;
        },
        resetPagination: (state) => { 
            state.pageNo = 1; 
            state.pageSize = 10; 
        },
        setProfilePageNo: (state, action) => { 
            state.profilePageNo = action.payload; 
        },
        setProfilePageSize: (state, action) => { 
            state.profilePageSize = action.payload;
        },
        resetProfilePagination: (state) => { 
            state.profilePageNo = 1; 
            state.profilePageSize = 10;
        },
        updatePagination: (state, action: PayloadAction<any>) => {
            state.startRec = action.payload.startRec;
            state.pageSize = action.payload.pageSize;
            state.pageNo = action.payload.pageNo;
        },
        updateProfilePagination: (state, action: PayloadAction<any>) => {
            state.startProfileRec = action.payload.startProfileRec;
            state.profilePageSize = action.payload.profilePageSize;
            state.profilePageNo = action.payload.profilePageNo;
        },
    },
    extraReducers: (builder) => {
        builder
            .addCase(getAccountGeoFenceZoneType.pending, (state) => {
                state.status = 'loading';
                state.isLoading = true;
            })
            .addCase(getAccountGeoFenceZoneType.fulfilled, (state, action) => {
                state.status = 'idle';
                state.isLoading = false;
                state.zoneTypeList = action.payload?.Data;
            })
            .addCase(getAccountGeoFenceZoneType.rejected, (state) => {
                state.status = 'failed';
                state.isLoading = false;
            })
            .addCase(getAccountGeoFenceZoneTypeById.pending, (state) => {
                state.status = 'loading';
                state.isLoading = true;
            })
            .addCase(getAccountGeoFenceZoneTypeById.fulfilled, (state, action) => {
                state.status = 'idle';
                state.isLoading = false;
            })
            .addCase(getAccountGeoFenceZoneTypeById.rejected, (state) => {
                state.status = 'failed';
                state.isLoading = false;
            })
            .addCase(DeleteAccountGeoFenceZoneType.pending, (state) => {
                state.status = 'loading';
                state.isLoading = true;
            })
            .addCase(DeleteAccountGeoFenceZoneType.fulfilled, (state, action) => {
                state.status = 'idle';
                state.isLoading = false;
            })
            .addCase(DeleteAccountGeoFenceZoneType.rejected, (state) => {
                state.status = 'failed';
                state.isLoading = false;
            })
            .addCase(GetAccountGeoFenceZone.pending, (state) => {
                state.status = 'loading';
                state.isLoading = true;
            })
            .addCase(GetAccountGeoFenceZone.fulfilled, (state, action) => {
                state.status = 'idle';
                state.isLoading = false;
                state.zoneList = action?.payload?.Data;
                if (state?.zoneList?.length > 0) { 
                    state.totalItems = state.zoneList[0]?.TotalRecords ?? 0;
                } else { 
                    state.totalItems = 0; 
                }
                //  state.pageNo = action.meta.arg?.pageNumber ?? 1;
                // state.pageSize = action.meta.arg?.pageSize ?? 10;
            })
            .addCase(GetAccountGeoFenceZone.rejected, (state) => {
                state.status = 'failed';
                state.isLoading = false;
            })
            .addCase(GetAccountGeoFenceZoneById.pending, (state) => {
                state.status = 'loading';
                state.isLoading = true;
            })
            .addCase(GetAccountGeoFenceZoneById.fulfilled, (state, action) => {
                state.status = 'idle';
                state.isLoading = false;
            })
            .addCase(GetAccountGeoFenceZoneById.rejected, (state) => {
                state.status = 'failed';
                state.isLoading = false;
            })
            .addCase(SystemGeoFenceBoundaryBehavior.pending, (state) => {
                state.status = 'loading';
                state.isLoading = true;
            })
            .addCase(SystemGeoFenceBoundaryBehavior.fulfilled, (state, action) => {
                state.status = 'idle';
                state.isLoading = false;
            })
            .addCase(SystemGeoFenceBoundaryBehavior.rejected, (state) => {
                state.status = 'failed';
                state.isLoading = false;
            })
            .addCase(GetAccountGeoFenceProfile.pending, (state) => {
                state.status = 'loading';
                state.isLoading = true;
            })
            .addCase(GetAccountGeoFenceProfile.fulfilled, (state, action) => {
                state.status = 'idle';
                state.isLoading = false;
                state.profileList = action.payload?.Data;
                if (state.profileList?.length > 0) { 
                    state.totalProfileItems = state.profileList[0]?.TotalRecords ?? 0;
                } else { 
                    state.totalProfileItems = 0; 
                }
                // state.profilePageNo = action.meta.arg?.pageNumber ?? 1;
                // state.profilePageSize = action.meta.arg?.pageSize ?? 10;
            })
            .addCase(GetAccountGeoFenceProfile.rejected, (state) => {
                state.status = 'failed';
                state.isLoading = false;
            })
            .addCase(GetAccountGeoFenceProfileById.pending, (state) => {
                state.status = 'loading';
                state.isLoading = true;
            })
            .addCase(GetAccountGeoFenceProfileById.fulfilled, (state, action) => {
                state.status = 'idle';
                state.isLoading = false;
                state.profileList = action.payload?.Data
            })
            .addCase(GetAccountGeoFenceProfileById.rejected, (state) => {
                state.status = 'failed';
                state.isLoading = false;
            })
            .addCase(SystemRadiusUnitController.pending, (state) => {
                state.status = 'loading';
                state.isLoading = true;
            })
            .addCase(SystemRadiusUnitController.fulfilled, (state, action) => {
                state.status = 'idle';
                state.isLoading = false;
                state.radiusUnit = action.payload?.Data
            })
            .addCase(SystemRadiusUnitController.rejected, (state) => {
                state.status = 'failed';
                state.isLoading = false;
            })
    }
})
export const { setPageNo, setPageSize, resetPagination, setProfilePageNo,setProfilePageSize, resetProfilePagination, updatePagination, updateProfilePagination  } = geofencingSlice.actions;
export const GeofencingState = (state: RootState) => state.geofencing;
export default geofencingSlice.reducer